import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterManagementSettingsAppEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const helpCenterManagementSettingsAppEntryPoint: EntryPoint<
	HelpCenterManagementSettingsAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterManagementSettingsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-management-settings-app" */ './HelpCenterManagementSettingsApp.tsx',
	),
	getPreloadProps: () => ({}),
});
